<template>

		<div class="container py-4">
      <div class="mt-5 col-12 col-lg-6 col-md-7 mx-auto">
      <div class="card w-100">
        <div class="card-bod px-4 px-sm-5 py-5">
        <h4 class="card-title mb-4">驗證</h4>
        <form action="">

          <div class="form-group mb-4 d-flex">
            <input v-model="verifyCode" class="form-control" placeholder="請輸入驗證碼">
            <button class="btn btn-success px-2 py-1 text-nowrap" @click="getVerifyCode" :disabled="disabled">{{btnTitle}}</button>
          </div>
          <p v-if="disabled" class="text-danger">驗證碼會發送到合約簽約人的信箱</p>
          <button class="btn btn-primary px-4 py-2" @click="onSubmit">送出</button>
        </form>
      </div>
      </div>
    </div>

		</div>
</template>

<script>
import axios from 'axios';
var currentURL = (document.URL);
const sgid = currentURL.split('://')[1].split('/')[3];
const uuid = currentURL.split('://')[1].split('/')[2];
const checksum = currentURL.split('://')[1].split('/')[4];
const baseUrl = process.env.VUE_APP_API_URL
const sendVerifyCodeEmailUrl = `${baseUrl}/api/v1/signings/request_otp.json`
const verifyCodeUrl = `${baseUrl}/api/v1/signings/verify_external_otp.json`

export default {
  name: 'verificationView',
  props: {
    msg: String
  },
  data() {
    return {
      phoneNumber: "",
      verifyCode: "",
      disabled: false,
      btnTitle: "獲取驗證碼",
      temp:""

    };
  },
  methods:{
    onSubmit(e) {
      e.preventDefault()
      axios.post(verifyCodeUrl,{
        sgid: sgid,
        uuid: uuid,
        otp_attempt: this.verifyCode
      }).then(res => {
        console.log('res',res);
        if (res.status == 200) {
          const token = res.data.token
          localStorage.setItem('token', token);
          alert('登入成功');
          this.$router.push(`/signing_digital_contract/${uuid}/${sgid}/${checksum}`)
        } else {
          alert('登入失敗');
        }
      });

    },
    getVerifyCode(e) {
      e.preventDefault()

      let time = 30;
      let timer = setInterval(() => {
        this.btnTitle = time + "秒後重試";
        this.disabled = true;
        time--;
        if (time == 0) {
          clearInterval(timer);
          this.btnTitle = "獲取驗證碼";
          this.disabled = false;
        }
      }, 1000);
      this.temp=Math.floor(Math.random()*100000)+100000;
      console.log('getVerifyCode');

      axios.post(sendVerifyCodeEmailUrl,{
        sgid: sgid,
        uuid: uuid
      }).then(res => {
        console.log('res',res);
      });
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content{
	background-color: #def0f3;
}
.card{
  box-shadow: 0 0 10px #c8c8c87b;
  border: none;
}

</style>
